import { Button } from "@redelair-sa/intiza-ui";

type SubmitButtonType = {
  text: string;
  onClick?: () => void;
  loading: boolean;
  type?: "button" | "submit";
  fullWidth?: boolean;
};

const SubmitButton = ({
  text,
  onClick,
  loading = false,
  type = "button",
  fullWidth = false
}: SubmitButtonType) => {
  return (
    <Button
      shape="pill"
      type={type}
      fullWidth={fullWidth}
      loading={loading}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

export default SubmitButton;
